import ReactModal from 'react-modal';

import { isIdCheckFundingRequirementComplete } from './isIdCheckFundingRequirementComplete';
import { TGetFundingRequirementsResponse } from '../../../../api/lending/edge';
import { useGetFundingRequirement } from '../../../../api/lending/lapiHooks';
import { LoadingSpinner } from '../../../../components/LoadingSpinner/LoadingSpinner';
import { IDCheckIcon } from '../../../../components/svg/IDCheckIcon';
import { useModal } from '../../../store/ModalProvider';
export const ID_CHECK_PENDING_MODAL = 'IDCheckPendingModal';

export const IDCheckPendingModal = ({
  onClickForceShowOnfidoSMS,
  showOnfidoSMSInput = false,
}: {
  onClickForceShowOnfidoSMS: () => void;
  showOnfidoSMSInput?: boolean;
}) => {
  const REFETCH_INTERVAL = 10000;
  const { isOpen, closeModal } = useModal(ID_CHECK_PENDING_MODAL);

  useGetFundingRequirement({
    queryOptions: {
      refetchInterval: (query) => {
        const data = query.state.data as
          | TGetFundingRequirementsResponse
          | undefined;
        const fundingRequirements = data?.data ?? null;

        // Keep polling while the modal is open and the ID check requirement is
        // unresolved. We check the requirement status (not the onfido item
        // status) because a re-opened check (code 256) keeps a stale
        // `completed` item that would otherwise stop polling prematurely.
        if (
          isOpen &&
          !isIdCheckFundingRequirementComplete(fundingRequirements)
        ) {
          return REFETCH_INTERVAL;
        }

        return false;
      },
    },
  });

  return (
    <ReactModal
      className="absolute flex flex-col items-center border-none bg-transparent p-l text-m font-med text-structure-100"
      overlayClassName="fixed inset-0 bg-modal-overlay flex items-center justify-center"
      isOpen={isOpen}
      shouldCloseOnOverlayClick={false}
      ariaHideApp={false}
    >
      <div className="mb-l flex flex-col items-center justify-center text-l font-bold">
        <IDCheckIcon className="ml-xs block" />
        ID Check
      </div>
      <p className="m-0 mb-l text-center">
        {showOnfidoSMSInput && (
          <>
            We have texted you a link to complete your ID check. <br />
            Please complete the ID check.
          </>
        )}
        {!showOnfidoSMSInput && (
          <>
            You have an ID check in progress in another tab. <br />
            Please complete the ID check.
          </>
        )}
      </p>
      <div className="my-xl h-[1px] self-stretch bg-structure-80"></div>
      <p className="m-0 mb-l text-center">Waiting for ID Check results...</p>
      <LoadingSpinner />
      <div className="text-center">
        <p>Can't see ID check?</p>
        <div className="text-s font-med">
          If it doesn’t load{' '}
          <button
            className="cursor-pointer border-none bg-transparent p-0 text-s font-med text-white underline"
            onClick={() => {
              onClickForceShowOnfidoSMS();
              closeModal();
            }}
          >
            Send yourself a text
          </button>
        </div>
      </div>
      <p className="mt-l text-center text-s font-reg">
        *This may take a few minutes to update
      </p>
    </ReactModal>
  );
};
